// extracted by mini-css-extract-plugin
var _1 = "PortalGroupingItem_icon__b6c8e";
var _2 = "PortalGroupingItem_iconWrapper__61872";
var _3 = "PortalGroupingItem_label__91715";
var _4 = "PortalGroupingItem_mask__77674";
var _5 = "PortalGroupingItem_placeholder__cfd22";
export { _1 as "icon", _2 as "iconWrapper", _3 as "label", _4 as "mask", _5 as "placeholder" }
